/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-08-17 09:56:43
 * @LastEditors: bbq
 * @LastEditTime: 2021-02-01 14:05:45
 */
import React, { Component } from 'react';
import { HotKeys } from 'react-hotkeys';
import classNames from 'classnames';
import { keyMap } from './config/tableKeyboardMap';
import { createByModuleType, deleteKeyByModuleId } from './createKeyMap';
import { keyDownOfShiftUp, handleArrowKeyDown } from './handleKeyDown';
import { stopCardTableHotKeyChange } from './config/stopHotKeyChange';
import { findNextFocusItemInTable } from './util/findNextFocusItemInTable';

function TableWithKeyboardChange(WrappedComponent) {
    return class WithKeyboardChange extends Component {
        constructor(props) {
            super(props);
        }

        componentDidMount() {
            // if (stopCardTableHotKeyChange(this.props)) { return; }

            createByModuleType.table(this.props._keyboardProps);
        }

        componentDidUpdate() {
            // if (stopCardTableHotKeyChange(this.props)) { return; }

            createByModuleType.table(this.props._keyboardProps);
        }

        componentWillUnmount() {
            // 部分情况下KeyByModuleId 没有清除  导致创建不能直接聚焦
            deleteKeyByModuleId(this.props.id);
        }

        // static tableStatusChanged({ props, status }) {
        //     if (status === 'edit' && !stopCardTableHotKeyChange(props)) {
        //         createByModuleType.table(props);
        //     } else {
        //         deleteKeyByModuleId(props.moduleId);
        //     }

        // }

        hotKeyWithEnter = ({ e, ViewModel, moduleId, target, itemType }) => {
            let { id, pageScope } = this.props._keyboardProps,
                { orderOfHotKey } = pageScope;

            if (!orderOfHotKey) {
                console.warn('not find orderOfHotKey in getHotKeyConfig');
                return;
            }

            if (orderOfHotKey?.length) {
                let index = orderOfHotKey.indexOf(id),
                    nextAreaId = orderOfHotKey[(index + 1) % orderOfHotKey.length];

                let activeTabDom = document.querySelector(`.card-table-tab[tabid=${nextAreaId}]`);
                activeTabDom?.focus();
            }
        };

        // hotKeyWithArrow = ({ e, ViewModel, moduleId, itemType, target }) => {
        //     let eventTarget = target || e.target;
        //     let { orderOfHotKey } = this.props.getHotKeyConfig ? this.props.getHotKeyConfig() : {};
        //     if (!orderOfHotKey) {
        //         console.warn('not find orderOfHotKey in getHotKeyConfig');
        //         return;
        //     }

        //     handleArrowKeyDown({
        //         eventTarget,
        //         ViewModel,
        //         moduleId,
        //         orderOfHotKey,
        //         itemType,
        //         keyCode: e.keyCode,
        //     });
        // };

        render() {
            let { flex } = this.props;
            return (
                <HotKeys
                    keyMap={keyMap}
                    handlers={{
                        shiftUp: keyDownOfShiftUp.bind(this, this.props.id),
                        shiftDown: keyDownOfShiftUp.bind(this, this.props.id),
                    }}
                    className={classNames({
                        'flex-container': flex,
                        'table-with-keyboard-change': true,
                    })}
                >
                    <WrappedComponent
                        {...this.props}
                        // tableStatusChanged={WithKeyboardChange.tableStatusChanged}
                        hotKeyWithEnter={this.hotKeyWithEnter}
                        hotKeyWithArrow={this.hotKeyWithArrow}
                    />
                </HotKeys>
            );
        }
    };
}

export default TableWithKeyboardChange;
